import { useQueryClient } from '@tanstack/react-query'

import SetIsActive from '@/common/components/SetIsActive'
import useMutationUpdateGame from '@/modules/game/api/hooks/useMutationUpdateGame'
import { GameQueryKeys } from '@/modules/game/keys'

import type { GetGameListTableData } from '@/modules/game/type'

interface IsPopularGameProps {
	row: GetGameListTableData
}

export function IsPopularGame({ row }: IsPopularGameProps) {
	const queryClient = useQueryClient()
	const { mutateAsync: updateGame } = useMutationUpdateGame()

	const handleMutate = async (value: boolean) => {
		await updateGame({
			id: row.id,
			payload: {
				isPopular: value,
			},
		})
		queryClient.invalidateQueries({
			queryKey: [GameQueryKeys.GetGameList],
		})
	}

	return (
		<SetIsActive
			defaultChecked={row.isPopular}
			onMutate={handleMutate}
			successMessage="อัพเดทยอดนิยมสำเร็จ"
		/>
	)
}
